export default __webpack_public_path__ + "static/media/QRcode_Group.85d83e19.jpg";